﻿import anime from 'animejs';
import barba from "@barba/core";
import LocomotiveScroll from 'locomotive-scroll';

import WindowUtils from './utils/WindowUtils';
import Utils from "./utils/Utils";
import Type8 from './utils/Type8';

// import GridDebug from './utils/GridDebug';
// new GridDebug(22,0);

const WU = new WindowUtils();

const isHome = () => document.body.classList.contains('home');
const isCabinet = () => document.body.classList.contains('page-template-tpl-cabinet');
const isOffre = () => document.body.classList.contains('page-template-tpl-offre');
const isFaq = () => document.body.classList.contains('page-template-tpl-questions');

const cursor = document.querySelector('.cursor');
const cursorContent = document.querySelector('.cursor_content');

if (WU.isTouch()) {
    document.body.classList.add('isTouch');
}

const loadImages = (parent = document) => {
    // parent.querySelectorAll('.imageRender:not(.imageRender--loaded)').forEach((img) => {
    //     let url = img.getAttribute('data-url');
    //     let cover = img.querySelector('.imageRender_cover');

    //     Utils.loadImage(url).then(() => {
    //         cover.style.backgroundImage = 'url(' + url + ')';
    //         img.classList.add('imageRender--loaded');
    //     });
    // });
};

const loadVideo = (video) => {
    let req = new XMLHttpRequest();
    req.open('GET', '/wp-content/themes/parhelie/assets/videos/' + video, true);
    req.responseType = 'blob';

    req.onload = function() {
        if (this.status === 200) {
            // console.log("LOADED", video);
            let videoBlob = this.response;
            let vid = URL.createObjectURL(videoBlob); // IE10+
        }
    }
    req.onerror = function() {
        console.log("ERROR", video);
    }

    req.send();
};
// const loadVideos = () => {
//     loadVideo('Intro.mp4');
//     loadVideo('Intro_Boucle.mp4');
//     loadVideo('Cabinet.mp4');
//     loadVideo('Cabinet_Boucle.mp4');
//     loadVideo('Offre.mp4');
//     loadVideo('Offre_Boucle.mp4');
//     loadVideo('Questions.mp4');
//     loadVideo('Questions_Boucle.mp4');
// };
// loadVideos();

let scroll;
let circles;

function numberWithDots(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

const createScroll = (parent = document) => {
    scroll = new LocomotiveScroll({
        el: parent.querySelector('.lcs[data-scroll-container]'),
        smooth: true,
        getSpeed: true,
        getDirection: true,
        gestureDirection: 'vertical',
        direction: 'vertical',
        tablet: {
            smooth: false
        },
        smartphone: {
            smooth: false
        }
    });

    scroll.stop();

    scroll.on('call', (value, way, obj) => {
        let calls = (typeof value === 'string') ? [value] : value;
        scrollAnimations(calls, way, obj);
    });

    circles = document.querySelectorAll('.circle');

    let progressBar = document.querySelector('.menuOpen_progress_bar');
    let r = parseInt(progressBar.getAttribute('r')) + 1;
    let c = Math.PI * 2 * r;
    progressBar.removeAttribute('style');

    let s, l, progress, pct;
    scroll.on('scroll', (instance) => {
        s = instance.scroll.y;
        l = instance.limit.y;
        
        progress = (s / l) * 100;
        pct = Math.round(((100 - progress) / 100) * c);
        document.querySelector('.menuOpen_progress_bar').style.strokeDashoffset = pct + "px";

        if (instance.direction == 'down' && s > WU.w.h * 0.5) {
            document.querySelector('.topbar').classList.add('hidden');
        } else {
            document.querySelector('.topbar').classList.remove('hidden');
        }

        circles.forEach((circle) => {
            let value = circle.getAttribute('data-value');
            circle.querySelector('.circle_label').innerHTML = numberWithDots(Math.round(value * (s / l)));
        })
    });

};

const scrollAnimations = (calls, way, obj) => {
    calls.forEach(call => {
        if (call === 'moveVideoBackground') {
            if (way === 'enter') {
                document.querySelector('.videoBackground').classList.remove('left');
            } else {
                document.querySelector('.videoBackground').classList.add('left');
            }
        }
        if (call === 'toggleVideoOffre') {
            if (way === 'enter') {
                document.querySelector('.videoBackground').classList.add('hidden');
            } else {
                document.querySelector('.videoBackground').classList.remove('hidden');
            }
        }
        if (call === 'hideVideoBackground') {
            if (way === 'enter') {
                document.querySelector('.videoBackground').classList.remove('hidden');
            } else {
                document.querySelector('.videoBackground').classList.add('hidden');
            }
        }
        if (call === 'toggleVideoNextPage') {
            // if (document.querySelector('.videoBackground_footer')) {
                if (way === 'enter') {
                    // document.querySelector('.videoBackground_footer').play();
                    document.querySelector('.videoBackground').classList.add('footer');
                } else {
                    // document.querySelector('.videoBackground_footer').pause();
                    document.querySelector('.videoBackground').classList.remove('footer');
                }
            // }
        }
        if (call === 'toggleScrollButtons') {
            if (way === 'enter') {
                document.querySelector('.scrollDown').classList.remove('visible');
                document.querySelector('.scrollTop').classList.add('visible');
            } else {
                document.querySelector('.scrollDown').classList.add('visible');
                document.querySelector('.scrollTop').classList.remove('visible');
            }
        }
        if (call === 'showBreadcrumbs') {
            if (way === 'enter') {
                document.querySelector('.breadcrumbs').classList.remove('visible');
            } else {
                document.querySelector('.breadcrumbs').classList.add('visible');
            }
        }
        if (call === 'showWords') {
            if (way === 'enter') {
                let words = obj.el.querySelectorAll('.w--hidden');
                words.forEach((w, index) => {
                    setTimeout(() => {
                        w.classList.remove('w--hidden');
                    }, index * 60);
                });
            }
        }
        if (call === 'initOffres') {
            if (way === 'enter') {
                document.querySelector('.schema').classList.add('schema--ready');
            }
        }
        
        if (call === 'toggleVideo') {
            let videoPlayer = obj.el.querySelector('video');
            if (videoPlayer && videoPlayer.getAttribute('src') != '') {
                if (way === 'enter') {
                    videoPlayer.play();
                } else {
                    videoPlayer.pause();
                }
            }
        }
    });
};

const scrollTop = (force) => {
    if (!scroll) return;
    if (force) {
        scroll.scrollTo(0, { duration: 0, disableLerp: true });
    } else {
        scroll.scrollTo(0, { duration: 1000, easing: [0.90, 0.00, 0.00, 1.00] });
    }
};

const scrollTo = (elt, offset = 0) => {
    scroll.scrollTo(elt, { duration: 1000, easing: [0.90, 0.00, 0.00, 1.00], offset: offset });
};

const initCollapses = () => {
    if (document.querySelectorAll('[data-collapse]')) {
        document.querySelectorAll('[data-collapse]').forEach((collapse) => {
            let collapseToggle = collapse.querySelector('[data-collapse-toggle]');
            let collapseContent = collapse.querySelector('[data-collapse-content]');
            collapseToggle.addEventListener('click', (e) => {
                let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                collapse.toggleAttribute('data-collapse-opened');
                anime({
                    targets: collapseContent,
                    height: collapse.hasAttribute('data-collapse-opened') ? contentHeight : 0,
                    easing: 'easeOutExpo',
                    duration: 900,
                    complete: () => { scroll.update(); }
                });

                if (collapse.getAttribute('data-collapse-scrollto') && collapse.hasAttribute('data-collapse-opened')) {
                    let offset = collapse.getAttribute('data-collapse-scrollto') ? collapse.getAttribute('data-collapse-scrollto') : 0;
                    scrollTo(collapseToggle, offset);
                }
            })
        });

        const resizeCollapsesContents = () => {
            if (document.querySelectorAll('[data-collapse-opened]')) {
                document.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
                    let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                    collapse.querySelector('[data-collapse-content]').style.height = contentHeight + 'px';
                });
            }
        };

        window.addEventListener('resize', Utils.debounce(() => { resizeCollapsesContents() }), { passive: true });
    }
};

const initMagnetic = () => {
    document.querySelectorAll('.magnetic').forEach((elt) => {
        let area = elt.querySelector('.magnetic_area');
        let target = elt.querySelector('.magnetic_button');
        let movement = 1;

        area.addEventListener('mousemove', function(e){
            let areaBounding = area.getBoundingClientRect();
            let relX = e.pageX - areaBounding.left;
            let relY = e.pageY - areaBounding.top;
            let scrollTop = 0; // window.pageYOffset || document.documentElement.scrollTop;

            anime.set(target, {
                translateX: (relX - areaBounding.width/2) * movement,
                translateY: (relY - areaBounding.height/2 - scrollTop) * movement,
            });
        });
        
        area.addEventListener('mouseleave', function(e){
            anime.set(target, {
                translateX: 0,
                translateY: 0,
            });
        });
    });
};

const initPageVideos = () => {
    let DOM = {
        vWrap: document.querySelector('.videoBackground'),
        vIntro: document.querySelector('.videoBackground_intro'),
        vLoop: document.querySelector('.videoBackground_loop')
    };

    if (!isHome() && DOM.vIntro && DOM.vLoop) {
        DOM.vIntro.play();
        DOM.vIntro.addEventListener('ended', () => {
            DOM.vWrap.classList.add('loop');
            DOM.vLoop.play();
        }, false);
    }
};

const updateCursor = (value) => {
    cursorContent.innerHTML = value;
}

const initCursor = () => {
    window.addEventListener('mousemove', e => {
        cursor.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
    });

    document.addEventListener('mouseleave', () => {
        cursor.classList.remove('cursor--visible');
    });

    document.querySelectorAll('[data-cursor]').forEach((elt) => {
        elt.addEventListener('mouseenter', (e) => {
            let value = elt.getAttribute('data-cursor');
            let style = elt.getAttribute('data-cursor-style');
            cursorContent.innerHTML = value;
            cursor.classList.add('cursor--visible');
            if (style) { cursor.setAttribute('data-style', style); }
            document.body.classList.add('hasCursor');
        });
        elt.addEventListener('mouseleave', () => {
            cursor.classList.remove('cursor--visible');
            document.body.classList.remove('hasCursor');
            cursor.removeAttribute('data-style');
        });
    });
}

const audioProgress = (id) => {
    let audio = document.querySelector('.vocals_player[data-vocal="' + id + '"]');
    let bar = document.querySelector('.vocals_list li[data-vocal="' + id + '"]').querySelector('.vocals_progress_bar');
    let duration = parseFloat(audio.duration);
    let currentTime = parseFloat(audio.currentTime);
    let progress = currentTime/duration;

    let txtWrap = document.querySelector('.vocals_txt');
    let txt = document.querySelector('.vocals_txt_item[data-vocal="' + id + '"]');
    let txtContent = txt.querySelector('.vocals_txt_item_content');
    let words = txtContent.querySelectorAll('.w');
    let nbWords = txtContent.getAttribute('data-words');
    txtContent.setAttribute('data-duration', duration);

    let currentWord = Math.round(nbWords * progress);
    // if (currentWord < words.length){
        // words[currentWord].classList.add('active');
    // }
    words.forEach((w, index) => {
        if (index <= currentWord) {
            w.classList.add('active');
        }
    });

    let pxToScroll = txt.offsetHeight - txtWrap.offsetHeight;
    let newProgress = ((progress - 0.1) / (0.9 - 0.1));
    if (newProgress < 0) newProgress = 0;
    if (newProgress > 1) newProgress = 1;
    let newScroll = newProgress * pxToScroll * -1;

    anime.set(bar, { scaleX: progress });
    anime.set(txt, { translateY: newScroll });

};

let playerInterval, equalizerInterval;

const playVocal = (id) => {
    let audio = document.querySelector('.vocals_player[data-vocal="' + id + '"]');
    let toggle = document.querySelector('.vocals_txt_item_toggle[data-vocal="' + id + '"]');
    let itemList = document.querySelector('.vocals_list li[data-vocal="' + id + '"]');

    audio.play();
    updateCursor('PAUSE');
    toggle.setAttribute('data-cursor', 'PAUSE');
    playEqualizer(id);
    itemList.classList.add('playing');

    playerInterval = setInterval(function () {
        audioProgress(id);
    }, 30);
};

const pauseVocal = (id) => {
    let audio = document.querySelector('.vocals_player[data-vocal="' + id + '"]');
    let toggle = document.querySelector('.vocals_txt_item_toggle[data-vocal="' + id + '"]');
    let itemList = document.querySelector('.vocals_list li[data-vocal="' + id + '"]');
    
    audio.pause();
    updateCursor('PLAY');
    toggle.setAttribute('data-cursor', 'PLAY');
    itemList.classList.remove('playing');
    
    pauseEqualizer(id);
    
    clearInterval(playerInterval);
};

const resetVocal = (id, forced = false, nextId = 0) => {
    let audio = document.querySelector('.vocals_player[data-vocal="' + id + '"]');
    let toggle = document.querySelector('.vocals_txt_item_toggle[data-vocal="' + id + '"]');
    let itemList = document.querySelector('.vocals_list li[data-vocal="' + id + '"]');
    let itemTxt = document.querySelector('.vocals_txt_item[data-vocal="' + id + '"]');
    
    clearInterval(playerInterval);

    audio.currentTime = 0;
    anime.set(itemList.querySelector('.vocals_progress_bar'), { scaleX: 0 });

    updateCursor('PLAY');
    toggle.setAttribute('data-cursor', 'PLAY');
    itemList.classList.remove('playing');
    
    pauseEqualizer(id);

    setTimeout(() => {
        let words = itemTxt.querySelectorAll('.w');
        words.forEach((w) => { w.classList.remove('active'); });

        anime({ targets: itemTxt, translateY: 0, duration: 800, easing: 'easeOutExpo', complete: () => {
            if (nextId != 0 && nextId != '0') {
                document.querySelector('.vocals_list li[data-vocal="' + nextId + '"]').click();
            }
        } });
    }, forced ? 0 : 1000);
};

const playEqualizer = (id) => {
    let itemList = document.querySelector('.vocals_list li[data-vocal="' + id + '"]');
    let bars = itemList.querySelectorAll('.equalizer_bar');

    equalizerInterval = setInterval(function () {
        bars.forEach(function(bar) {
            bar.style.transform = 'scaleY(' + Math.random() + ')';
        });
    }, 30);
};

const pauseEqualizer = (id) => {
    let itemList = document.querySelector('.vocals_list li[data-vocal="' + id + '"]');
    let bars = itemList.querySelectorAll('.equalizer_bar');
    clearInterval(equalizerInterval);

    bars.forEach(function(bar) {
        bar.removeAttribute('style');
    });
}

const initVocals = () => {

    if (document.querySelector('.vocals')) {
        let DOM = {
            parent: document.querySelector('.vocals'),
            textItems: document.querySelectorAll('.vocals_txt_item'),
            list: document.querySelector('.vocals_list'),
            listItems: document.querySelectorAll('.vocals_list li'),
            vocals: document.querySelectorAll('.vocals_player')
        };

        DOM.textItems.forEach((item) => {
            let toggle = item.querySelector('.vocals_txt_item_toggle');
            let id = item.getAttribute('data-vocal');
            let audio = DOM.parent.querySelector('.vocals_player[data-vocal="' + id + '"]');
            
            toggle.addEventListener('click', () => {
                if (audio.paused) {
                    playVocal(id);
                } else {
                    pauseVocal(id)
                }
            });
        });

        DOM.listItems.forEach((item) => {
            let audio = item.querySelector('.vocals_player');
            let id = item.getAttribute('data-vocal');
            let nextId = item.getAttribute('data-vocal-next');

            audio.addEventListener('ended', () => {
                resetVocal(id, false, nextId);
            });

            item.addEventListener('click', () => {
                if (item.classList.contains('playing')) {
                    pauseVocal(id);
                } else {
                    if (DOM.list.querySelector('li.active') && !item.classList.contains('active')) {
                        let prevId = DOM.list.querySelector('li.active').getAttribute('data-vocal');
                        pauseVocal(prevId);
                        resetVocal(prevId, true);
                        DOM.list.querySelector('li.active').classList.remove('active');
                        DOM.parent.querySelector('.vocals_txt_item.active').classList.remove('active');
                    }

                    playVocal(id);
                    DOM.parent.querySelector('.vocals_txt_item[data-vocal="' + id + '"]').classList.add('active');
                    item.classList.add('active');
                }
            })
        });
    }
}

const page = () => {

    new Type8();

    loadImages();
    window.Sharer.init();

    initCollapses();
    initMagnetic();

    if (!WU.isTouch()) {
        initCursor();
    }

    circles = document.querySelectorAll('.circle');

    if (document.querySelector('.footer_topButton')) {
        document.querySelector('.footer_topButton').addEventListener('click', (e) => {
            scrollTop();
        });
    }
    if (document.querySelector('.scrollTop')) {
        document.querySelector('.scrollTop').addEventListener('click', (e) => {
            scrollTop();
        });
    }
    

    document.querySelectorAll('[data-scrollto]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            let attr = link.getAttribute('data-scrollto');
            let elt;
            if (attr) {
                elt = document.querySelector(attr);
            }
            if (elt) {
                scrollTo(elt);
            }
        });
    });

    document.querySelector('.menuOpen').addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.menu').classList.add('visible');
        document.querySelector('.menu_background').classList.add('visible');
        document.querySelector('.loadingScreen--yellow').setAttribute('data-state', 'normal');
        setTimeout(() => {
            document.querySelector('.menuClose').classList.add('visible');

            anime({
                targets: '.menu_col',
                translateY: [50,0],
                opacity: [0,1],
                easing: 'easeOutExpo',
                duration: 800,
                delay: anime.stagger(100)
            });
        }, 500);
        setTimeout(() => {
            document.querySelector('.marquee--menu').classList.add('visible');
        }, 500);
    });

    document.querySelector('.menuClose').addEventListener('click', (e) => {
        e.preventDefault();
        anime({
            targets: '.menu_col',
            translateY: [0, 50],
            opacity: [1, 0],
            easing: 'easeOutExpo',
            duration: 800,
        });
        document.querySelector('.marquee--menu').classList.remove('visible');
        document.querySelector('.menu_background').classList.remove('visible');
        document.querySelector('.menuClose').classList.remove('visible');
        document.querySelector('.loadingScreen--yellow').setAttribute('data-state', 'difference');

        setTimeout(() => {
            document.querySelector('.menu').classList.remove('visible');
        }, 1800);
    });
    
    document.querySelector('.topbar_logo').addEventListener('click', (e) => {
        document.querySelector('.loadingScreen--yellow').setAttribute('data-state', 'normal');
    });

    document.querySelector('.contactToggle').addEventListener('click', (e) => {
        e.preventDefault();
        let contact = document.querySelector('.contact');
        contact.classList.add('visible');
        scroll.stop();
    });

    document.querySelector('.contact_close').addEventListener('click', (e) => {
        e.preventDefault();
        let contact = document.querySelector('.contact');
        contact.classList.remove('visible');
        scroll.start();
    });

    document.querySelector('.contact_background').addEventListener('click', (e) => {
        e.preventDefault();
        let contact = document.querySelector('.contact');
        contact.classList.remove('visible');
        
        cursor.classList.remove('cursor--visible');
        document.body.classList.remove('hasCursor');
        scroll.start();
    });

    if (isHome()) {

        let introLogoC1 = document.querySelector('.logo').querySelector('.c1');
        let introLogoC2 = document.querySelector('.logo').querySelector('.c2');
        let introLogoLetters = document.querySelector('.logo').querySelectorAll('.l');

        let contents = document.querySelectorAll('.baseline_rotator_item');
        let contentsIndex = 0;

        let vWrap = document.querySelector('.videoBackground');
        let vIntro = document.querySelector('.videoBackground_intro');
        let vLoop = document.querySelector('.videoBackground_loop');

        let showTitle = (index) => {
            contents[contentsIndex].classList.add('active');

            return anime({
                targets: contents[index].querySelectorAll('.titleRow > p'),
                translateY: ['101%', '0%'],
                opacity: [0,1],
                easing: 'easeInOutExpo',
                duration: 1000,
                delay: anime.stagger(100)
            });
        };

        let hideTitle = (index) => {
            return anime({
                targets: contents[index].querySelectorAll('.titleRow > p'),
                translateY: ['0%', '-101%'],
                opacity: [1,0],
                easing: 'easeInOutExpo',
                duration: 800,
                delay: anime.stagger(100),
                complete: () => {
                    contents.forEach((item) => {
                        item.classList.remove('active');
                    });
                }
            });
        };

        setTimeout(() => {
            document.querySelector('.homeIntro .logo').classList.add('animated');
            anime({
                targets: introLogoC1,
                opacity: [0,1],
                duration: 600,
                easing: 'linear'
            });
            anime({
                targets: introLogoC2,
                opacity: [0,1],
                duration: 600,
                delay: 50,
                easing: 'linear'
            });
            setTimeout(() => {
                anime({
                    targets: introLogoLetters,
                    opacity: [0,1],
                    duration: 600,
                    delay: anime.stagger(100),
                    easing: 'linear',
                    complete: () => {
                        setTimeout(() => {
                            hideIntro();
                        }, 2000);
                    }
                });
            }, 200);
        }, 2500);

        let hideIntro = () => {

            document.querySelector('.homeIntro').classList.add('hidden');
            document.querySelector('.loadingScreen--yellow').setAttribute('data-state', 'difference');

            vIntro.play();
            vIntro.addEventListener('ended', () => {
                vWrap.classList.add('loop');
                vLoop.play();
            }, false);

            setTimeout(() => {
                if (contents.length > 0) {
                    showTitle(0);
                    document.querySelector('.header_link').classList.add('visible');
                    document.querySelector('.header .button').classList.add('visible');
        
                    setInterval(() => {
                        hideTitle(contentsIndex).finished.then(() => {
                            contentsIndex = contentsIndex == contents.length - 1 ? 0 : contentsIndex + 1;
                            showTitle(contentsIndex);
                        })
                    }, 6000);
                }
            }, 5000);
        }
    }

    initPageVideos();
    initVocals();

    const activateOffreIntro = (index) => {
        if (document.querySelector('.offre_item.active')) {
            document.querySelectorAll('.offre_item.active').forEach((elt) => {
                elt.classList.remove('active');
            });
        }
        document.querySelectorAll('.offre_item[data-offre="' + index + '"]').forEach((elt) => {
            elt.classList.add('active');
        });

        if (document.querySelector('.offre_intro.active')) {
            document.querySelector('.offre_intro.active').classList.remove('active');
        }
        document.querySelector('.offre_intro[data-offre="' + index + '"]').classList.add('active');

        if (document.querySelector('.schema_step.schema_step--active')) {
            document.querySelectorAll('.schema_step.schema_step--active').forEach((elt) => {
                elt.classList.remove('schema_step--active');
            });
        }
        document.querySelectorAll('.schema_step[data-step="' + index + '"]').forEach((elt) => {
            elt.classList.add('schema_step--active');
            document.querySelector('.schema').setAttribute('data-step', index);
        });
    };

    const activateOffre = (index) => {
        if (document.querySelector('.offreContainer.active')) {
            document.querySelector('.offreContainer.active').classList.remove('active');
        }
        document.querySelector('.offreContainer[data-offre="' + index + '"]').classList.add('active');
    };

    let currentOffreOpened = 1;
    if (document.querySelectorAll('.offre_item').length > 0) {
        document.querySelectorAll('.offre_item').forEach((item) => {
            item.addEventListener('click', (e) => {
                currentOffreOpened = item.getAttribute('data-offre');

                activateOffreIntro(currentOffreOpened);
                activateOffre(currentOffreOpened);

                scroll.update();
                if (document.querySelector('.offreContainer.active')) {
                    scrollTo('.offreContainer.active');
                }
            });

            item.addEventListener('mouseenter', (e) => {
                let tmpIndex = item.getAttribute('data-offre');
                activateOffreIntro(tmpIndex);
            });

            item.addEventListener('mouseleave', () => {
                if (currentOffreOpened) {
                    activateOffreIntro(currentOffreOpened);
                } else {

                    if (document.querySelector('.offre_item.active')) {
                        document.querySelectorAll('.offre_item.active').forEach((elt) => {
                            elt.classList.remove('active');
                        });
                    }
                    if (document.querySelector('.offre_intro.active')) {
                        document.querySelector('.offre_intro.active').classList.remove('active');
                    }
                    if (document.querySelector('.schema_step.schema_step--active')) {
                        document.querySelectorAll('.schema_step.schema_step--active').forEach((elt) => {
                            elt.classList.remove('schema_step--active');
                        });
                    }
                    document.querySelector('.schema').setAttribute('data-step', "0");
                }
            });

        })
    }

    // SCHEMA CABINET
    if (document.querySelectorAll('.pres_schema_content').length > 0) {
        let contents = document.querySelectorAll('.pres_schema_content');
        let txts = document.querySelectorAll('.pres_schemaTxt_content');
        let contentsIndex = 0;

        setInterval(() => {
            contents[contentsIndex].classList.remove('active');
            txts[contentsIndex].classList.remove('active');

            setTimeout(() => {
                contentsIndex = contentsIndex == contents.length - 1 ? 0 : contentsIndex + 1;
                contents[contentsIndex].classList.add('active');
                setTimeout(() => {
                    txts[contentsIndex].classList.add('active');
                }, 150);
            }, 500);
        }, 5000);
    }


    if (document.querySelector('.header') && !isHome()) {
        
        setTimeout(() => {
            let TL = anime.timeline({
                complete: () => {
                    if (document.querySelector('.scrollDown')) {
                        document.querySelector('.scrollDown').classList.add('visible');
                    }
                }
            });

            if (document.querySelector('.header_title')) {
                TL.add({
                    targets: '.header_title .titleRow > p',
                    translateY: ['105%', '0%'],
                    easing: 'easeInOutExpo',
                    duration: 1600,
                    delay: anime.stagger(100)
                });
            }
            
            if (document.querySelector('.header_intro')) {
                TL.add({
                    targets: '.header_intro',
                    translateY: ['6rem', '0'],
                    opacity: [0, 1],
                    easing: 'easeOutExpo',
                    duration: 1600,
                    delay: 500
                });
            }

            setTimeout(() => {
                scroll.start();
            }, 3000);

        }, 3000);
    }

    if (document.querySelector('.articleInfos')) {
        setTimeout(() => {
            document.querySelectorAll('.articleInfos').forEach((elt) => {
                elt.classList.add('visible');
            })
        }, 2500);
    }



};

const initPage = () => {
    createScroll();
    WU.scrollToTop();
    page();
};

const hideLoading = (delay = 800) => {
    setTimeout(() => {
        if (!isHome()) {
            document.querySelector('.loadingScreen--yellow').setAttribute('data-state', 'difference');
        }
        document.querySelector('.marquee--loading').classList.remove('visible');
        setTimeout(() => {
            document.querySelector('.loadingScreen--blue').classList.add('hidden');
            setTimeout(() => {
                document.querySelector('.loadingScreen--yellow').classList.add('hidden');
                // setTimeout(() => {
                //     console.log("add hidden on yellow");
                //     document.querySelector('.loadingScreen--yellow').setAttribute('data-state', 'difference');
                // }, 2000);
            }, 200);
        }, 300);
    }, delay);
};

const showLoading = () => {
    document.querySelector('.loadingScreen--yellow').classList.remove('hidden');
    setTimeout(() => {
        document.querySelector('.loadingScreen--blue').classList.remove('hidden');
        setTimeout(() => {
            document.querySelector('.marquee--loading').classList.add('visible');
        }, 300);
    }, 200);
};

(function () {

    Utils.preloadHTMLImages(document.body.innerHTML).then(() => {
        initPage();
        hideLoading();
    });

    barba.hooks.enter((data) => {
        scrollTop(true);
    });

    barba.hooks.after(() => {
        scroll.update();
        document.querySelector('.menuOpen_progress_bar').removeAttribute('style');
    });

    barba.init({
        debug: false,
        timeout: 10000,
        cacheIgnore: true,
        transitions: [
            {
                name: 'default',
                leave() {
                    return new Promise(resolve => {

                        cursor.classList.remove('cursor--visible');
                        document.body.classList.remove('hasCursor');
                        
                        showLoading();
                        setTimeout(() => {
                            resolve();
                        }, 1200);
                        
                    });
                },
                enter(data) {
                    let done = this.async();
                    Utils.setNewAttrs(data.next.html);
                    Utils.preloadHTMLImages(data.next.html).then(() => {
                        done();

                        setTimeout(() => {
                            page();
                        }, 600);

                        hideLoading();
                    });
                }
            }
        ]
    });


})();